import jsDig from 'utils/jsDig';

export default (value, baseCurrency, selectedCurrency) => {
  const decimalPlaces = countDecimals(value);
  const allRates = require("data/currencyRates.json");
  const conversionRate = jsDig([baseCurrency, selectedCurrency], allRates);
  const newValue = (value * conversionRate).toFixed(decimalPlaces);
  return newValue;
}

const countDecimals = function (value) {
  if (!value) return 0;
  if (Math.floor(value.valueOf()) === value.valueOf()) return 0;
  return value.toString().split(".")[1].length || 0; 
}